export function useBadgeVisibility() {
	const badges = {
		revenue: {
			label: "New",
			start: "2026-05-10T00:00:00",
			expire: "2026-06-01T23:59:59",
		},

		marketing: {
			label: "Beta",
			start: "2026-05-14T00:00:00",
			expire: "2026-07-01T23:59:59",
		},

		events: {
			label: "updates",
			start: "2026-05-01T00:00:00",
			expire: "2026-08-01T23:59:59",
		},
	};

	const isVisible = (key) => {
		const badge = badges[key];

		if (!badge) return false;

		const now = new Date();

		const start = badge.start ? new Date(badge.start) : null;
		const expire = badge.expire ? new Date(badge.expire) : null;

		if (start && now < start) return false;

		if (expire && now > expire) return false;

		return true;
	};

	const getBadge = (key) => {
		if (!isVisible(key)) return null;

		return badges[key];
	};

	return {
		getBadge,
	};
}
